import React from 'react';
import theme from './OptionMoreInfoModal.module.scss';
import { ButtonBar, Modal, ModalBody, ModalFooter, ModalHeader } from '@ygtechnologies/bygr-frontend-component-library';
import { ConfiguratorOptionDto } from '@/services/configurator';
import { Button } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { BuyerOptionCardPrice } from '../BuyerOptionCard/BuyerOptionCardPrice';
import { ProductMoreInfoModalContent } from '../ProductMoreInfoModal/ProductMoreInfoModalContent';
import { OptionSelectButton } from '../BuyerOptionCard/OptionSelectButton';

export interface OptionMoreInfoModalProps {
    option: ConfiguratorOptionDto;
    isOpen: boolean;
    toggleModal: () => void;
}

export const OptionMoreInfoModal: React.FC<OptionMoreInfoModalProps> = ({ isOpen, toggleModal, option }) => {
    const product = option.product!;

    return (
        <Modal size="lg" isOpen={isOpen} toggle={toggleModal}>
            <ModalHeader />
            <ModalBody>
                <ProductMoreInfoModalContent
                    product={product}
                    headerContent={
                        <div className={theme.priceWrapper}>
                            <BuyerOptionCardPrice option={option} />
                        </div>
                    }
                />
            </ModalBody>

            <ModalFooter>
                <ButtonBar className={theme.buttonBar}>
                    <ButtonBar.Left />
                    <ButtonBar.Right>
                        <Button variant="tertiary" onClick={toggleModal}>
                            <Trans>Close</Trans>
                        </Button>
                        <OptionSelectButton option={option} onSelected={toggleModal} />
                    </ButtonBar.Right>
                </ButtonBar>
            </ModalFooter>
        </Modal>
    );
};
